import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const ApplicationSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { applicationItems, handleAsyncFilter, hasNextPage, isLoading, noItemsText, onNextPage } =
        useData();

    const handleClick = (application: Item) => {
        onChange(application);
        onClose?.(application);
    };

    return (
        <SingleSelectPanel
            className={className}
            entityType={ENTITY_TYPE}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            itemSelected={value}
            items={applicationItems}
            label={SEARCH}
            noItemsFoundText={noItemsText}
            onFilter={handleAsyncFilter}
            onNextPage={onNextPage}
            onSelected={handleClick}
            testId={testId}
        />
    );
};

export default ApplicationSelectPanelField;
